import { ReactNode, useMemo } from 'react';
import { useHighlightedMappingsMap } from '../../../../../../stores/mappingStore';
import { MasterDescriptorWithHorizontalLevelType } from '../../../../../../types';
import { getMasterDescriptorStyling } from './utils';

type MasterDescriptorCellPropsType = {
    masterDescriptor?: MasterDescriptorWithHorizontalLevelType | undefined;
    children: ReactNode;
};

function MasterDescriptorCell({ masterDescriptor, children }: MasterDescriptorCellPropsType) {
    const highlightedMappingsMap = useHighlightedMappingsMap();

    const { styles, classes } = useMemo(() => {
        if (masterDescriptor) {
            return getMasterDescriptorStyling(masterDescriptor, highlightedMappingsMap);
        } else {
            return { styles: {}, classes: '' };
        }
    }, [masterDescriptor, highlightedMappingsMap]);

    return (
        <td style={styles} className={classes}>
            {children}
        </td>
    );
}

export default MasterDescriptorCell;
